import { IPolygon } from "./IPolygon";

export interface ICustomPolygon extends IPolygon {
	points: google.maps.LatLng[];
	isSgPolygon?: boolean;
}
